import React, { useEffect, useState } from 'react'
import { Section, SectionTitle, HistoryList, HistoryItem, HistoryItemContent, HistoryItemText, UserImage } from '../style'
import { Calendar } from 'lucide-react'
import axios from 'axios'
import { useSearchParams } from 'react-router-dom'

interface HistoryType {
  id: number
  action: string
  serviceId: number
  userId: number
  dateTime: string
  description: string
  oldValue: string | null
  newValue: string | null
  user: {
    id: number
    name: string
  }
}

const History = () => {
  const [history, setHistory] = useState<HistoryType[]>([])
  const [ searchParams ] = useSearchParams()
  const id = searchParams.get('id')

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/pcp/history/${id}`)
      .then(response => {
        if(response.data) setHistory(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])
  
  return (
    // <Section>
    //   <SectionTitle><AlignLeft size={16} /> Description</SectionTitle>
    //   <div>Add a more detailed description...</div>
    // </Section>
    <Section>
      <SectionTitle> <Calendar size={20} /> Histórico da ordem </SectionTitle>
      <HistoryList>
        {history.map((item, index) => 
          <HistoryItem key={index}>
            <HistoryItemContent>
              <UserImage>JL</UserImage>
              <HistoryItemText>
                <span>{item.user.name}</span>
                {item.description}
              </HistoryItemText>
            </HistoryItemContent>
          </HistoryItem>
        )}
      </HistoryList>
    </Section>
  )
}

export default History